module.exports = __webpack_public_path__ + "static/media/landing-page.90b92186.png";